import {without} from 'lodash';

export default class PlayerCameras {
  static SPLIT_CAMERA = 'split-camera';
  static FORWARD_CAMERA = 'forward-camera';
  static REAR_CAMERA = 'rear-camera';
  static DRIVER_CAMERA = 'driver-camera';
  static PASSENGER_CAMERA = 'passenger-camera';
  static IN_CABIN_CAMERA = 'incabin-camera';

  static ALL_CAMERAS = [
    PlayerCameras.SPLIT_CAMERA,
    PlayerCameras.FORWARD_CAMERA,
    PlayerCameras.REAR_CAMERA,
    PlayerCameras.DRIVER_CAMERA,
    PlayerCameras.PASSENGER_CAMERA
  ];
  static ADPLUS_CAMERAS = [
    PlayerCameras.SPLIT_CAMERA,
    PlayerCameras.FORWARD_CAMERA,
    PlayerCameras.IN_CABIN_CAMERA,
    PlayerCameras.DRIVER_CAMERA,
    PlayerCameras.PASSENGER_CAMERA
  ]

  static all(includeSplitCamera = true, machineType = null) {
    if (includeSplitCamera) {
      if(machineType === 4){
        return [...PlayerCameras.ADPLUS_CAMERAS];
      } else {
        return [...PlayerCameras.ALL_CAMERAS];
      }
    }
    
    if(machineType === 4){
      return without(PlayerCameras.ADPLUS_CAMERAS, PlayerCameras.SPLIT_CAMERA);
    } else {
      return without(PlayerCameras.ALL_CAMERAS, PlayerCameras.SPLIT_CAMERA);
    }
  }
}
